import LoginForm from "./LoginForm/LoginForm";
import "./App.css";
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import ContentArea from "./ContentArea/ContentArea";
import SingleTicket from "./SingleTicket/SingleTicket";
import MyTicketsView from "./MyTicketView/MyTicketsView";
import KnowledgeBase from "./KnowledgeBase/KnowledgeBase";
import Article from "./Article/Article";
import CreateArticle from "./CreateArticle/CreateArticle";
import { BrowserRouter, Routes, Route, useNavigate, useLocation, Navigate  } from "react-router-dom";
import MFAuth from "./MFAuth/MFAuth";
import moment from "moment";
import jwt_decode from "jwt-decode";
import { Suspense, useEffect, useState, lazy } from "react";
import { CircularProgress } from "@mui/material";
import ReportScreen from "./ReportScreen/ReportScreen";
import CodeVerificationScreen from "./CodeVerificationScreen/CodeVerificationScreen";
import ProtectedRoute from "./ProtectedRoute/ProtectedRoute";
import MyApproval from "./MyApproval/MyApproval";
import Category from "./Master/Category";
import SubCategory from "./Master/SubCategory";
import Users from "./Users/Users";
import Newticket from "./CreateNewTicket/Newticket";
import Status from "./StatusEdit/Status";
import { loginRequest } from "./authConfig";
import { msalConfig } from "./authConfig";
import axiosApiInstance from "./axios";
import {
  MsalProvider,
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  MsalAuthenticationTemplate,
  useIsAuthenticated,
  useMsal,
} from "@azure/msal-react";
import { PublicClientApplication, InteractionType } from "@azure/msal-browser";
import { InteractionStatus } from "@azure/msal-browser";
const msalInstance = new PublicClientApplication(msalConfig);

// const Users = lazy(() => import('./Users/Users'))
const IncidentHome = lazy(() => import("./IncidentReporting/IncidentHome"));
const NewSecurity = lazy(() => import("./NewSecurityIncident/NewSecurity"));
// const Newticket = lazy(() => import('./CreateNewTicket/Newticket'))

function App() {  
  const basename = process.env.REACT_APP_HOMEPAGE || '/';
  const pathSegments = window.location.pathname.split('/').filter(Boolean);
  const basePath = pathSegments.includes('ServicedeskUI') ? '/ServicedeskUI' : '';
  
  useEffect(() => {
    fetch(`.${basePath}/config.json`).then((response) =>
      response.json().then((data) => {
        localStorage.setItem("url", data.REACT_APP_API_ENDPOINT);
      })
    );
  }, []);

  const [getUserInfo, setgetUserInfo] = useState([]);

  const isAuthenticated = useIsAuthenticated();
  const [isauthencation, setisauthencation] = useState(false);

  const [accessToken, setAccessToken] = useState(null);
  const [loading, setLoading] = useState(false);

  const { instance, inProgress, accounts } = useMsal();
  const [higherRole, setHigherRole] = useState("");


  const reloadCount = Number(sessionStorage.getItem("reloadCount")) || 0;

  useEffect(() => {
    if (inProgress === InteractionStatus.None && !isAuthenticated) {
      instance
        .loginRedirect(loginRequest)

        .catch((e) => {
          console.error(e);
        });
    }
  });

  function RequestAccessToken() {
    const request = {
      ...loginRequest,
      account: accounts[0],
    };

    // Silently acquires an access token which is then attached to a request for Microsoft Graph data
    instance
      .acquireTokenSilent(request)
      .then((response) => {
        if (response.idToken) {
          localStorage.setItem("token", response.idToken);
          setAccessToken(response.idToken);
          setLoading(true); 
        }
      })
      .catch((error) => {
        if (error instanceof InteractionRequiredAuthError) {
          // If silent token acquisition fails, redirect to login
          instance.acquireTokenRedirect(request);
        } else {
          console.error('Token acquisition error: ', error);
          setAccessToken(null);
        }
      });
  }

  useEffect(() => {
    if(isAuthenticated){
      RequestAccessToken();
    }
  }, [isAuthenticated, instance, accounts]);

  useEffect(() => {
    if (accessToken) {
      const currentDate = moment().format('YYYY-MM-DD HH:mm:ss');
      axiosApiInstance.get(`/Account/GetUser?date=${currentDate}`).then((resp) => {
        setgetUserInfo(resp.data.data);
        localStorage.setItem("id", resp.data.data.id);
        localStorage.setItem("userRole", JSON.stringify(resp.data.data.roles));
        const userRoles = JSON.parse(localStorage.getItem("userRole"));
        setisauthencation(true);
        if (userRoles?.includes("TMS-UI-Admin")) {
          setHigherRole("TMS-UI-Admin");
        } else {
          setHigherRole("");
        }
      });
      if (reloadCount < 1) {
        sessionStorage.setItem("reloadCount", String(reloadCount + 1));
        window.location.reload();
      } else {
        sessionStorage.removeItem("reloadCount");
        
      }
    }
  }, [accessToken]);

  useEffect(() => {
    if (accessToken) {
      const decodedToken = jwt_decode(accessToken);
      const tokenExpiryTime = decodedToken.exp * 1000; // Convert to milliseconds
  
      const checkTokenExpiry = () => {
        const currentTime = Date.now();
        if (currentTime > tokenExpiryTime) {
          // Token has expired, redirect to login
          instance.loginRedirect(loginRequest);
        }
      };
  
      const tokenCheckInterval = setInterval(checkTokenExpiry, 60000); // Check every minute
  
      return () => clearInterval(tokenCheckInterval); // Clean up the interval on unmount
    }
  }, [accessToken, instance]);


  const userRoles = JSON.parse(localStorage.getItem("userRole"));


  return (
    <>
      {/* <AuthenticatedTemplate>
        {isauthencation ? <Pages /> : ""}
      </AuthenticatedTemplate> */}
      <AuthenticatedTemplate>
      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        authenticationRequest={loginRequest}
      >
        {isauthencation ? <Pages /> : ""}
      </MsalAuthenticationTemplate>
    </AuthenticatedTemplate>
    </>
  );

  function Pages() {
    return (
      <BrowserRouter basename={basename}>
        <div className="App">
          <div className="App2">
            <Routes>
              <Route path="/" element={<Navigate to="/mytickets" replace />} />
              <Route exact path="/mytickets" element={<MyTicketsView  />} />
              <Route path="/open/:ticketId" element={<SingleTicket />} />
              {higherRole === "TMS-UI-Admin" && (
                <Route exact path="/tickets" element={<ContentArea />} />
              )}

              <Route exact path="/knowledge" element={<KnowledgeBase />} />
              <Route exact path="/Article/:id" element={<Article />} />
              <Route exact path="/add" element={<CreateArticle />} />

              {higherRole === "TMS-UI-Admin" && (
                <Route exact path="/report" element={<ReportScreen />} />
              )}

              {higherRole === "TMS-UI-Admin" && (
                <Route
                  exact
                  path="/users"
                  element={<Users fetchedRole={userRoles} />}
                />
              )}

              <Route
                exact
                path="/security"
                element={
                  <Suspense fallback={<CircularProgress />}>
                    <NewSecurity />
                  </Suspense>
                }
              />
              {higherRole === "TMS-UI-Admin" && (
                <Route path="/category" element={<Category />} />
              )}
              {higherRole === "TMS-UI-Admin" && (
                <Route path="/subcategory" element={<SubCategory />} />
              )}
              {higherRole === "TMS-UI-Admin" && (
                <Route path="/status" element={<Status />} />
              )}

              <Route
                exact
                path="/create"
                element={
                  <Suspense fallback={<CircularProgress />}>
                    <Newticket />
                  </Suspense>
                }
              />
              <Route path="/myapproval" element={<MyApproval />} />
            </Routes>
          </div>
        </div>
      </BrowserRouter>
    );
  }
}

export default App;